var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100% - 48px)"}},[(_vm.series.length > 0)?_c('apexchart',{attrs:{"width":"100%","height":"100%","type":"line","options":_vm.options,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }